import { ff } from '@atlassian/jira-feature-flagging';

export const initDevTools = () => {
	if (ff('uip.vc.devtools', false)) {
		window.VCDevTools = () =>
			import(/* webpackChunkName: "vc-dev-tools" */ './dev-tools').then(({ startVCDevTools }) =>
				startVCDevTools?.(),
			);
	}
};
